import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    mainContainer: () => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap'
    })
});
